import { SectionHeading } from "./ProductSelector";
import { MEDIA } from "../../data/products";
import { Home, Layers3, Building2, Square, Hammer } from "lucide-react";

const USE_CASES = [
  {
    icon: Home,
    title: "Poddasza skośne",
    text: "Użytkowe i nieużytkowe. Układ jedno- i dwuwarstwowy między i pod krokwiami.",
  },
  {
    icon: Square,
    title: "Ścianki działowe",
    text: "Lekka zabudowa karton-gips. Izolacja akustyczna i termiczna.",
  },
  {
    icon: Layers3,
    title: "Sufity podwieszane",
    text: "Tłumienie hałasu i poprawa komfortu akustycznego pomieszczeń.",
  },
  {
    icon: Building2,
    title: "Podłogi na legarach",
    text: "Stropy między legarami drewnianymi i konstrukcjami z profili stalowych.",
  },
  {
    icon: Hammer,
    title: "Konstrukcje szkieletowe",
    text: "Domy drewniane, stalowe konstrukcje szkieletowe, modernizacje.",
  },
];

export default function Applications() {
  return (
    <section
      id="zastosowanie"
      data-testid="applications-section"
      className="bg-zinc-50 py-20 lg:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          overline="05 · Zastosowanie"
          title="Gdzie zastosować?"
          subtitle="Uniwersalna izolacja dla nowoczesnego budownictwa mieszkaniowego i użyteczności publicznej."
        />

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
          {/* Big image card */}
          <div className="lg:col-span-5 lg:row-span-2 relative bg-black border-2 border-black overflow-hidden min-h-[400px]">
            <img
              src={MEDIA.worker}
              alt="Montaż wełny mineralnej"
              className="w-full h-full object-cover absolute inset-0 opacity-80"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-8">
              <div className="inline-block bg-red-600 text-white font-tech text-[10px] uppercase tracking-widest font-bold px-2.5 py-1 mb-4">
                Profesjonalny montaż
              </div>
              <h3 className="font-display text-3xl lg:text-4xl text-white uppercase leading-none tracking-tight">
                Łatwy w obróbce.<br />
                Trwały w użyciu.
              </h3>
            </div>
          </div>

          {/* Use case cards */}
          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-6 lg:gap-8">
            {USE_CASES.map((uc, idx) => (
              <article
                key={uc.title}
                data-testid={`application-${idx}`}
                className="bg-white border-2 border-zinc-200 hover:border-red-600 hover:shadow-lg transition p-6 group"
              >
                <div className="flex items-start justify-between mb-4">
                  <uc.icon
                    className="h-9 w-9 text-zinc-900 group-hover:text-red-600 transition"
                    strokeWidth={1.6}
                  />
                  <span className="font-tech text-[10px] uppercase tracking-widest text-zinc-400">
                    0{idx + 1}
                  </span>
                </div>
                <h3 className="font-display text-lg uppercase tracking-tight text-zinc-900 mb-2 leading-snug">
                  {uc.title}
                </h3>
                <p className="text-sm text-zinc-600 leading-relaxed">
                  {uc.text}
                </p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
